// @ts-ignore
/* eslint-disable */
// API 更新时间：
// API 唯一标识：
import * as App from "./App";
import * as Acl from "./Acl";
import * as DashboardRole from "./DashboardRole";
import * as HqRole from "./HqRole";
import * as UserFriend from "./UserFriend";
import * as AppUser from "./AppUser";
import * as AdminUser from "./AdminUser";
import * as DashboardProfile from "./DashboardProfile";
import * as OSS from "./OSS";
import * as Sms from "./Sms";
import * as Captcha from "./Captcha";
import * as AdminFile from "./AdminFile";
import * as AppFile from "./AppFile";
import * as OCR from "./OCR";
import * as AppPayment from "./AppPayment";
import * as Payment from "./Payment";
import * as Finance from "./Finance";
import * as HqFinance from "./HqFinance";
import * as Auth from "./Auth";
import * as WeappAuth from "./WeappAuth";
import * as HqTenant from "./HqTenant";
import * as HqTenantDeposit from "./HqTenantDeposit";
import * as HqCity from "./HqCity";
import * as DashboardTenantProfile from "./DashboardTenantProfile";
import * as Notary from "./Notary";
import * as AlipayAuth from "./AlipayAuth";
import * as Health from "./Health";
import * as HqMonitoring from "./HqMonitoring";
import * as AppContact from "./AppContact";
import * as DashboardDepartment from "./DashboardDepartment";
import * as DashboardStaff from "./DashboardStaff";
import * as HqStaff from "./HqStaff";
import * as DashboardSetting from "./DashboardSetting";
import * as HqSetting from "./HqSetting";
import * as HqPlatformSetting from "./HqPlatformSetting";
import * as HqAuditLog from "./HqAuditLog";
import * as HqMenu from "./HqMenu";
import * as MeMenu from "./MeMenu";
import * as AppMessage from "./AppMessage";
import * as Order from "./Order";
import * as AppRentToBuyOrder from "./AppRentToBuyOrder";
import * as ESign from "./ESign";
import * as Contract from "./Contract";
import * as Store from "./Store";
import * as AppStore from "./AppStore";
import * as HqAiUsage from "./HqAiUsage";
import * as Asset from "./Asset";
import * as AssetCategory from "./AssetCategory";
import * as AssetTransfer from "./AssetTransfer";
import * as Product from "./Product";
import * as AppProduct from "./AppProduct";
import * as AppSkuInstallment from "./AppSkuInstallment";
import * as ProductCategory from "./ProductCategory";
import * as ProductSpu from "./ProductSpu";
import * as ProductSku from "./ProductSku";
import * as ProductSkuInstallment from "./ProductSkuInstallment";
import * as AppUserBankcard from "./AppUserBankcard";
import * as HqUserBankcard from "./HqUserBankcard";
export default {
  App,
  Acl,
  DashboardRole,
  HqRole,
  UserFriend,
  AppUser,
  AdminUser,
  DashboardProfile,
  OSS,
  Sms,
  Captcha,
  AdminFile,
  AppFile,
  OCR,
  AppPayment,
  Payment,
  Finance,
  HqFinance,
  Auth,
  WeappAuth,
  HqTenant,
  HqTenantDeposit,
  HqCity,
  DashboardTenantProfile,
  Notary,
  AlipayAuth,
  Health,
  HqMonitoring,
  AppContact,
  DashboardDepartment,
  DashboardStaff,
  HqStaff,
  DashboardSetting,
  HqSetting,
  HqPlatformSetting,
  HqAuditLog,
  HqMenu,
  MeMenu,
  AppMessage,
  Order,
  AppRentToBuyOrder,
  ESign,
  Contract,
  Store,
  AppStore,
  HqAiUsage,
  Asset,
  AssetCategory,
  AssetTransfer,
  Product,
  AppProduct,
  AppSkuInstallment,
  ProductCategory,
  ProductSpu,
  ProductSku,
  ProductSkuInstallment,
  AppUserBankcard,
  HqUserBankcard,
};
